import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import useAuth from 'hooks/useAuth'

import { GuardProps } from 'types'

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, isNewPasswordRequired } = useAuth()
  const navigate = useNavigate()

  const location = useLocation()
  const { id: invitationId } = useParams()

  // fetch invitationId and workspace name from url and save it to localStorage
  useEffect(() => {
    if (location.pathname.includes('invitation') && invitationId) {
      const searchParams = new URLSearchParams(location.search)
      const workspaceName = searchParams.get('workspace_name') || ''

      sessionStorage.setItem('workspaceName', workspaceName)
      sessionStorage.setItem('invitationId', invitationId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isLoggedIn || isNewPasswordRequired) {
      navigate('login', { replace: true })
      return
    }
    if (sessionStorage.getItem('invitationId')) {
      navigate('invitation', { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, isNewPasswordRequired])

  return children
}

export default AuthGuard
